// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1S-42","noInteraction":"EventWrapper_noInteraction__2O7Qd"};